var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 11,
    viewBox: "0 0 21 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.31112 1.30498C2.31112 1.86012 1.86109 2.31015 1.30595 2.31015C0.750812 2.31015 0.300781 1.86012 0.300781 1.30498C0.300781 0.749835 0.750812 0.299805 1.30595 0.299805C1.86109 0.299805 2.31112 0.749835 2.31112 1.30498Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32031 1.30498C4.32031 0.749835 4.77034 0.299805 5.32548 0.299805H19.3979C19.953 0.299805 20.4031 0.749835 20.4031 1.30498C20.4031 1.86012 19.953 2.31015 19.3979 2.31015H5.32548C4.77034 2.31015 4.32031 1.86012 4.32031 1.30498Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.30486 0.599375C0.915231 0.599375 0.599375 0.915231 0.599375 1.30486C0.599375 1.69449 0.915231 2.01034 1.30486 2.01034C1.69449 2.01034 2.01034 1.69449 2.01034 1.30486C2.01034 0.915231 1.69449 0.599375 1.30486 0.599375ZM0 1.30486C0 0.584205 0.584205 0 1.30486 0C2.02551 0 2.60972 0.584205 2.60972 1.30486C2.60972 2.02551 2.02551 2.60972 1.30486 2.60972C0.584205 2.60972 0 2.02551 0 1.30486Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32031 5.33134C4.32031 4.7762 4.77034 4.32617 5.32548 4.32617H19.3979C19.953 4.32617 20.4031 4.7762 20.4031 5.33134C20.4031 5.88648 19.953 6.33652 19.3979 6.33652H5.32548C4.77034 6.33652 4.32031 5.88648 4.32031 5.33134Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.33123C0 4.61057 0.584205 4.02637 1.30486 4.02637C2.02551 4.02637 2.60972 4.61057 2.60972 5.33123C2.60972 6.05188 2.02551 6.63609 1.30486 6.63609C0.584205 6.63609 0 6.05188 0 5.33123Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32031 9.35673C4.32031 8.80159 4.77034 8.35156 5.32548 8.35156H19.3979C19.953 8.35156 20.4031 8.80159 20.4031 9.35673C20.4031 9.91188 19.953 10.3619 19.3979 10.3619H5.32548C4.77034 10.3619 4.32031 9.91188 4.32031 9.35673Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.30486C0 8.58421 0.584205 8 1.30486 8C2.02551 8 2.60972 8.58421 2.60972 9.30486C2.60972 10.0255 2.02551 10.6097 1.30486 10.6097C0.584205 10.6097 0 10.0255 0 9.30486Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiSelectIcon);
export default __webpack_public_path__ + "static/media/multi-select-icon.016dbbecc5f78043b5d6ddf9c089b94b.svg";
export { ForwardRef as ReactComponent };